import { useTranslation } from 'react-i18next';

export interface LocalizedMethod {
  id: string;
  name: string;
  category: string;
  description: string;
  application_context: string;
  steps: any[];
  examples: any[];
}

export const useLocalizedMethods = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const localizeMethod = (method: any): LocalizedMethod => {
    const isEnglish = currentLang === 'en';
    
    return {
      id: method.id,
      name: isEnglish && method.name_en ? method.name_en : method.name,
      category: method.category,
      description: isEnglish && method.description_en ? method.description_en : method.description,
      application_context: isEnglish && method.application_context_en ? method.application_context_en : method.application_context,
      steps: isEnglish && method.steps_en ? method.steps_en : method.steps,
      examples: isEnglish && method.examples_en ? method.examples_en : method.examples || []
    };
  };

  const localizeMethods = (methods: any[]): LocalizedMethod[] => {
    return methods.map(localizeMethod);
  };

  return { localizeMethod, localizeMethods, currentLang };
};
